<template>
  <div class="pft-legend" flex="dir:left main:left cross:center" :style="style">
    <div class="pft-legend-text" :style="textStyle">{{ legend }}</div>
    <div class="pft-legend-color-block" :style="blockStyle"></div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"
import { defaultsDeep } from "lodash-es"
const props = defineProps<{
  legend: string
  color: string
  style?: any
  textStyle?: any
  blockStyle?: any
}>()
const style = computed(() => {
  return defaultsDeep(props.style, {
    width: "100%",
    height: "32px",
    padding: "0 16px",
    boxSizing: "border-box",
  })
})
const textStyle = computed(() => {
  return defaultsDeep(props.textStyle, {
    color: "#a3a6ad",
    fontSize: "14px",
    lineHeight: "32px",
  })
})
const blockStyle = computed(() => {
  return defaultsDeep(props.blockStyle, {
    width: "16px",
    height: "16px",
    marginRight: "8px",
    borderRadius: "4px",
    backgroundColor: props.color,
  })
})
</script>
<style lang="scss" scoped>
.pft-legend {
  display: flex;
}
</style>
